export default "__VITE_ASSET__b96fe7fb__"